import {createStore, compose, applyMiddleware, combineReducers} from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import {createBrowserHistory} from 'history';
import {createReduxHistoryContext} from 'redux-first-history';
import {reducerSlices} from '../reducers';

const browserHistory = createBrowserHistory();

const {createReduxHistory, routerMiddleware, routerReducer} =
  createReduxHistoryContext({history: browserHistory});

const rootReducer = combineReducers({
  router: routerReducer,
  ...reducerSlices,
});

let reduxHistory;

export function getReduxHistory() {
  return reduxHistory;
}

function configureStoreProd(initialState) {
  const middlewares = [thunk, routerMiddleware];

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middlewares)),
  );
}

function configureStoreDev(initialState) {
  const middlewares = [
    reduxImmutableStateInvariant(),
    thunk,
    routerMiddleware,
  ];

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares)),
  );
}

export default function configureStore(initialState) {
  const store =
    process.env.NODE_ENV === 'production'
      ? configureStoreProd(initialState)
      : configureStoreDev(initialState);
  reduxHistory = createReduxHistory(store);
  return store;
}
